import { useEffect, useState } from 'react';
const useTabDirection = () => {
    const [direction, setDirection] = useState('forward');
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Tab') {
                setDirection(e.shiftKey ? 'backward' : 'forward');
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, []);
    return direction;
};
export default useTabDirection;
